import { render, staticRenderFns } from "./sustainability.vue?vue&type=template&id=b85ca6ce"
import script from "./sustainability.vue?vue&type=script&lang=js"
export * from "./sustainability.vue?vue&type=script&lang=js"
import style0 from "./sustainability.vue?vue&type=style&index=0&id=b85ca6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports